import * as React from 'react';

interface Props {
    defaultCharacterName: string;
    isDead: boolean;
    className: string;
    name: string;
}
export default class CharacterName extends React.PureComponent<Props, {}> {
    static defaultProps = {
        isDead: false,
        className: '',
        defaultCharacterName: 'Hero With No Name',
    };

    render() {
        const { defaultCharacterName, isDead, className, name } = this.props;

        const classNames: Array<string> = ['ddbc-character-name', className];
        let displayName: string = name ? name : defaultCharacterName;
        if (isDead) {
            displayName = `(Dead) ${displayName}`;
        }

        return <div className={classNames.join(' ')}>{displayName}</div>;
    }
}
